import { createContext, useContext, useEffect } from 'react';

/** What the shell offers to its parts and to pages (spec 6.1). */
export interface ShellActions {
  openPalette: () => void;
  openShortcuts: () => void;
  focusNextRegion: () => void;
  /** The status bar's page context ("Orders · v4 · unsaved changes"); null clears it. */
  setPageStatus: (text: string | null) => void;
}

const noop = () => {};

export const ShellContext = createContext<ShellActions>({
  openPalette: noop,
  openShortcuts: noop,
  focusNextRegion: noop,
  setPageStatus: noop,
});

export function useShell(): ShellActions {
  return useContext(ShellContext);
}

/** Shows `text` as the page context in the status bar while the calling page is mounted. */
export function usePageStatus(text: string | null): void {
  const { setPageStatus } = useShell();
  useEffect(() => {
    setPageStatus(text);
    return () => setPageStatus(null);
  }, [text, setPageStatus]);
}
